module.exports = __webpack_public_path__ + "img/organize_your_library.85a39236.svg";